export function useBrToast() {
    const toast = useToast();

    function successToast(title: string, description?: string) {
        if (!import.meta.client) {
            return undefined;
        }

        return toast.add({
            title,
            description,
            color: 'success'
        });
    }

    function errorToast(title: string, description?: string) {
        if (!import.meta.client) {
            return undefined;
        }

        return toast.add({
            title,
            description,
            color: 'error'
        });
    }

    function warningToast(title: string, description?: string) {
        if (!import.meta.client) {
            return undefined;
        }

        return toast.add({
            title,
            description,
            color: 'warning'
        });
    }

    return {
        successToast,
        errorToast,
        warningToast
    };
}
